import axios from "axios"
import ApiStore from "./ApiStore";
// import Moment from 'moment'
// import { extendMoment } from 'moment-range';
// const moment = extendMoment(Moment);
// var querystring = require('querystring');

export class LivechatStore extends ApiStore{
  constructor() {
    super();

  }

  getImageUploadUrl(){
    return axios.defaults.baseURL+'/livechat/faq/image_upload';
  }

  uploadImage(blobInfo,success,failure){
    var xhr, formData;
    xhr = new XMLHttpRequest();
    xhr.withCredentials = true;
    xhr.open('POST', this.getImageUploadUrl());
    xhr.onload = function() {
      var json;

      if (xhr.status != 200) {
        failure('HTTP Error: ' + xhr.status);
        return;
      }
      json = JSON.parse(xhr.responseText);
      console.log('result',json);
      if (!json || typeof json.status != 'string') {
        failure('Invalid JSON: ' + xhr.responseText);
        return;
      }
      
      //success(json.img_src);
      if(json.data.length>0){
        success(json.data[0].img_src);
      }else{
        failure('Upload failed '+xhr.responseText);
      }
    };
    console.log('filename',blobInfo.filename());
    formData = new FormData();
    formData.append('files', blobInfo.blob(), blobInfo.filename());
    
    xhr.send(formData);
  }

  loadCategoryList(lang,completeFunc){
    axios.get('/livechat/faq/category_list?lang='+lang)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadQuestionList(cat_id,completeFunc){
    axios.get('/livechat/faq/question_list/'+cat_id)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadQuestionDoc(faq_id,completeFunc){
    axios.get('/livechat/faq/question/'+faq_id)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  saveCategory(postData,completeFunc,errorFunc){
    
    console.log('postData',postData)    
    axios.post('/livechat/faq/category',postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
    
  }

  saveCategorySort(postData,completeFunc,errorFunc){
    
    console.log('postData',postData)    
    axios.post('/livechat/faq/category_sort',postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
    
  }

  saveQuestion(postData,completeFunc,errorFunc){
    
    console.log('postData',postData)    
    axios.post('/livechat/faq/question',postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
    
  }

  saveQuestionSort(postData,completeFunc,errorFunc){
    
    console.log('postData',postData)    
    axios.post('/livechat/faq/question_sort',postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
    
  }

  delQuestion(faq_id,completeFunc,errorFunc){
    
    axios.delete('/livechat/faq/question/'+faq_id)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status=='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  delCategory(cat_id,completeFunc,errorFunc){
    
    axios.delete('/livechat/faq/category/'+cat_id)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status=='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }
}  

export default new LivechatStore()


// WEBPACK FOOTER //
// ./src/stores/LivechatStore.js